import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponseBase, HttpEventType } from '@angular/common/http';
import { BackendService } from 'core-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private backendSvc: BackendService) { }

  public postFile(formData: FormData): Observable<FileUploadResponseData> {

    let url = environment.uploadFileUrl;

    return this.backendSvc.post(url, formData, new HttpHeaders({
      'accept': '*'
    }), true)
      .pipe(map((n: FileUploadResponse) => {
        return n.data;
      }));

  }

  public getList(objectId: string): Observable<FileListResponseData> {

    let url = environment.fileListUrl + '/' + objectId;

    return this.backendSvc.get(url)
      .pipe(map((n: FileListResponse) => {
        return n.data;
      }));
  }

  public updateComment(fileId: string, comment: string): Observable<boolean> {
    let url = environment.fileUpdateCommentUrl + '/' + fileId;
    let data = { fileId, comment };

    return this.backendSvc.put(url, data)
      .pipe(map((n: FileUpdateResponse) => {
        return true;
      }));
  }

  public deleteFile(fileId: string): Observable<boolean> {
    let url = environment.fileDeleteUrl + '/' + fileId;

    return this.backendSvc.delete(url)
    .pipe(map((n: FileDeleteResponse) => {
      return true;
    }));

  }

}

export class FileUploadResponse {
  public code: number;
  public message: string;
  public data: FileUploadResponseData;
}

export class FileUploadResponseData {
  public fileId: string;
  public fileName: string;
  public contentType: string;
  public dateCreated: string;
}

export class FileListResponse {
  public code: number;
  public message: string;
  public data: FileListResponseData;
}

export class FileListResponseData {
  public items: FileListResponseDataItem[];
}

export class FileListResponseDataItem {
  public fileId: string;
  public fileName: string;
  public contentType: string;
  public dateCreated: string;
  public comment: string;
  public length: number;
}

export class FileUpdateResponse {
  public code: number;
  public message: string;
}

export class FileDeleteResponse {
  public code: number;
  public message: string;
}